import { baseRoutes } from "../../../helpers";

const accessRoute = {
  SUPERDASHBOARD: {
    path: `${baseRoutes.superBaseRoutes}/dashboard`,
  },
};

export default accessRoute;
  